import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, ReferenceLine } from "recharts";

const DOMAIN = [0, 100];
const DOT = { r: 4 };

export const Trend = ({ checks }) => {
  if (!checks.length) return null;
  const day = (c) => new Date(c.at).toLocaleDateString(undefined, { month: "short", day: "numeric" });
  const data = checks.map((c, i) => ({ day: checks.filter((o) => day(o) === day(c)).length > 1 ? `${day(c)}, ${new Date(c.at).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })}` : day(c), score: c.score, key: i }));
  return (
    <div className="mm-card p-5" data-testid="wellbeing-trend">
      <div className="flex items-baseline justify-between gap-3">
        <h2 className="font-semibold">Your wellbeing over time</h2>
        <span className="text-xs text-mm-muted" data-testid="wellbeing-trend-count">{checks.length} check{checks.length === 1 ? "" : "s"}</span>
      </div>
      <div className="h-40 mt-3">
        <ResponsiveContainer>
          <LineChart data={data}>
            <XAxis dataKey="day" fontSize={11} tickLine={false} />
            <YAxis domain={DOMAIN} fontSize={11} width={28} tickLine={false} />
            <ReferenceLine y={50} stroke="#F28FAD" strokeDasharray="4 4" />
            <Tooltip />
            <Line dataKey="score" stroke="var(--mm-primary)" strokeWidth={3} dot={DOT} />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <p className="text-xs text-mm-muted mt-2">The dashed line at 50 is where it's worth checking in with a professional.</p>
    </div>
  );
};
